/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import env from 'env'

export const getMeCompanyCardBillingAddress = (meta?: any) => ({
  type: 'api/company/GET_ME_COMPANY_CARD_BILLING_ADDRESS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/me/company/card/billing-address',
      method: 'GET',
    },
  },
  meta,
})
getMeCompanyCardBillingAddress.toString = () => 'api/company/GET_ME_COMPANY_CARD_BILLING_ADDRESS'

export const putMeCompanyCardBillingAddress =
({ firstName, lastName, countryId, stateId, city, postalCode, address1, phoneNumber }, data, meta?: any) => ({
  type: 'api/company/PUT_ME_COMPANY_CARD_BILLING_ADDRESS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: '/api/me/company/card/billing-address',
      method: 'PUT',
      data,
      query: { firstName, lastName, countryId, stateId, city, postalCode, address1, phoneNumber },
    },
  },
  meta,
})
putMeCompanyCardBillingAddress.toString = () => 'api/company/PUT_ME_COMPANY_CARD_BILLING_ADDRESS'
